<template>
    <svg
        fill="none"
        height="16"
        viewBox="0 0 58 16"
        width="58"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clip-rule="evenodd"
            d="M3 0C3 1.65685 1.65685 3 0 3V13C1.65685 13 3 14.3431 3 16H55C55 14.3431 56.3431 13 58 13V3C56.3431 3 55 1.65685 55 0H3Z"
            fill="#3F5D77"
            fill-rule="evenodd"
        />
        <text
            dominant-baseline="middle"
            fill="white"
            font-size="10"
            text-anchor="middle"
            x="29"
            y="10"
        >
            {{ $t("sidebar.updated") }}
        </text>
    </svg>
</template>
